import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M155.676,1349.19 L155.676,1686.49 C155.676,1729.48 190.525,1764.32 233.514,1764.32 L233.514,1764.32 L570.811,1764.32 L570.811,1920 L233.514,1920 C104.548,1920 -1.76214598e-12,1815.45 -1.76214598e-12,1686.49 L-1.76214598e-12,1686.49 L-1.76214598e-12,1349.19 L155.676,1349.19 Z M1920,1349.19 L1920,1686.49 C1920,1815.45 1815.45,1920 1686.49,1920 L1686.49,1920 L1349.19,1920 L1349.19,1764.32 L1686.49,1764.32 C1729.48,1764.32 1764.32,1729.48 1764.32,1686.49 L1764.32,1686.49 L1764.32,1349.19 L1920,1349.19 Z M960,544.865 C1189.27,544.865 1375.14,730.727 1375.14,960 C1375.14,1189.27 1189.27,1375.14 960,1375.14 C730.727,1375.14 544.865,1189.27 544.865,960 C544.865,730.727 730.727,544.865 960,544.865 Z M1686.49,0 C1815.45,0 1920,104.548 1920,233.514 L1920,233.514 L1920,570.811 L1764.32,570.811 L1764.32,233.514 C1764.32,190.525 1729.48,155.676 1686.49,155.676 L1686.49,155.676 L1349.19,155.676 L1349.19,0 Z M570.811,0 L570.811,155.676 L233.514,155.676 C190.525,155.676 155.676,190.525 155.676,233.514 L155.676,233.514 L155.676,570.811 L-1.76214598e-12,570.811 L-1.76214598e-12,233.514 C-1.76214598e-12,104.548 104.548,0 233.514,0 L233.514,0 L570.811,0 Z",
  fillRule: "nonzero",
  stroke: "none",
  strokeWidth: "1"
});

var IconScreenCaptureSolid = /*#__PURE__*/function (_Component) {
  _inherits(IconScreenCaptureSolid, _Component);

  var _super = _createSuper(IconScreenCaptureSolid);

  function IconScreenCaptureSolid() {
    _classCallCheck(this, IconScreenCaptureSolid);

    return _super.apply(this, arguments);
  }

  _createClass(IconScreenCaptureSolid, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconScreenCapture",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconScreenCaptureSolid.displayName = "IconScreenCaptureSolid";
  return IconScreenCaptureSolid;
}(Component);

IconScreenCaptureSolid.glyphName = 'screen-capture';
IconScreenCaptureSolid.variant = 'Solid';
IconScreenCaptureSolid.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconScreenCaptureSolid;
export { IconScreenCaptureSolid };